module.exports = __webpack_public_path__ + "static/media/lobby-arrow.2b2b5745.png";